import React, {
    useContext, useCallback, useState, useEffect
} from 'react';
import _ from 'lodash';
import { ModalNextProvider } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { ViewModelServiceContext, ViewModelForm } from 'gw-portals-viewmodel-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { useAuthentication } from 'gw-digital-auth-react';
import { useValidation } from 'gw-portals-validation-react';
import { MockUpUtil } from 'gw-portals-util-js';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import metadata from './DriverAssignmentPage.metadata.json5';
import messages from './DriverAssignmentPage.messages';

function DriverAssignmentPage(props) {
    const { wizardData: submissionVM, updateWizardData } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useContext(TranslatorContext);
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { authHeader } = useAuthentication();
    const {
        onValidate,
        initialValidation,
        isComponentValid,
        registerInitialComponentValidation,
        registerComponentValidation,
    } = useValidation('DriverAssignmentPage');

   
    const onNext = useCallback(async () => {
        _.unset(submissionVM.value, 'bindData');
        submissionVM.value = await LoadSaveService.updateDraftSubmission(
            submissionVM.value,
            authHeader
        );
        return submissionVM;
    }, [LoadSaveService, authHeader, submissionVM]);

    const generateOverrides = useCallback(() => {
        const vehicles = _.get(submissionVM, 'lobData.businessAuto.coverables.vehicles.value', []);
        const overrides = vehicles.map((vehicle, index) => {
            return {
                [`DriverAssignment${index}`]: {
                     submissionVM: submissionVM,
                     vehicleID: vehicle.fixedId,
                     updateWizardData: updateWizardData
                }
            };
        });

        return Object.assign({}, ...overrides);
    }, [translator, submissionVM]);

    const overrideProps = {
        '@field': {
            showOptional: false,
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        }
    };

    const isSubmissionQuoted = useCallback(() => {
        return _.get(submissionVM.value, 'baseData.periodStatus') === 'Quoted';
    }, [submissionVM]);

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps);
        },
        [submissionVM, overrideProps]
    );

    useEffect(() => {
        registerInitialComponentValidation(isSubmissionQuoted);
    }, [isSubmissionQuoted, registerInitialComponentValidation]);

    return (
        <WizardPage onNext={onNext} skipWhen={initialValidation} disableNext={!(submissionVM.aspects.valid && submissionVM.aspects.subtreeValid)}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
            />
        </WizardPage>
    );
}

DriverAssignmentPage.propTypes = wizardProps;
export default DriverAssignmentPage;
